import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface LmsState {
    lmsId: number | null
    newForm: boolean
}

const initialState: LmsState = {
    lmsId: null,
    newForm: true,
}

const lmsSlice = createSlice({
    name: 'lms',
    initialState,
    reducers: {
        setLmsId: (state, action: PayloadAction<number | null>) => {
            state.lmsId = action.payload
        },
        clearLmsId: (state) => {
            state.lmsId = null
        },
        setnewForm: (state, action: PayloadAction<boolean>) => {
            state.newForm = action.payload
        },
    },
})

export const { setLmsId, clearLmsId, setnewForm } = lmsSlice.actions
export default lmsSlice.reducer
